import { configureStore } from '@reduxjs/toolkit';
import commonSlice from './slice/commonSlice';
import priceUpdateSlice from './priceUpdate/slice';
import priceUpdateLogSlice from './priceUpdateLog/slice';
import userOnboardingSlice from './userOnboarding/slice';
import contactUsSlice from './contactUs/slice';
import settingSlice from './setting/slice';
import productSlice from './product/slice';
import ruleSlice from './rule/slice';

const Store = configureStore({
    reducer: {
        commonData: commonSlice,
        priceUpdate: priceUpdateSlice,
        priceUpdateLog: priceUpdateLogSlice,
        userOnboarding: userOnboardingSlice,
        contactUs: contactUsSlice,
        setting: settingSlice,
        product: productSlice,
        rule: ruleSlice
    }
});

export default Store;
